import { Box, Heading, SimpleGrid, VStack, Text, Circle } from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);
const MotionVStack = motion(VStack);

export default function Steps() {
  const steps = [
    { n: 1, title: "Limpeza", desc: "Lave e seque seus pés delicadamente antes da aplicação." },
    { n: 2, title: "Aplicar", desc: "Massageie o creme Sedapé nos seus pés usando movimentos circulares suaves." },
    { n: 3, title: "Desfrutar", desc: "Permita que seja absorvido e aproveite a maciez e a fragrância." },
  ];

  return (
    <MotionBox
      py={20}
      px={{ base: 6, md: 24 }}
      bg="white"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <Heading textAlign="center" mb={12} color="sedapePinkDark">
        Passos Simples para Pés Macios e Sedosos
      </Heading>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
        {steps.map((s, i) => (
          <MotionVStack
            key={i}
            p={8}
            bg="sedapeLight"
            borderRadius="xl"
            boxShadow="md"
            spacing={4}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.3, duration: 0.8, type: "spring", stiffness: 60 }}
            viewport={{ once: true }}
          >
            <Circle size="50px" bg="sedapeGold" color="white" fontWeight="bold">
              {s.n}
            </Circle>
            <Heading fontSize="xl" color="sedapePinkDark">
              {s.title}
            </Heading>
            <Text color="gray.700" textAlign="center">
              {s.desc}
            </Text>
          </MotionVStack>
        ))}
      </SimpleGrid>
    </MotionBox>
  );
}
